import { GetBy, C } from '../_app/cuchillo/core/Element';
import { Basics, isTouch } from '../_app/cuchillo/core/Basics';
import { Shffl } from '../_app/cuchillo/components/Shffl';
import CircleVisor from '../layout/CircleVisor';
import VideoMultiple from '../layout/VideoMultiple';
import ProgressScroller from './ProgressScroller';
import EventDispatcher from '../_app/cuchillo/core/EventDispatcher';

const TIME_FRAME = .01;

export default class ProjectsVisor {
  static instance = null;
  static getInstance(__dom) {
    if (!ProjectsVisor.instance) ProjectsVisor.instance = new ProjectsVisor(__dom);
    return ProjectsVisor.instance;
  }

  _calls = {
    click: e => this._click(e)
  }

  constructor(__dom) {
    if (ProjectsVisor.instance) return ProjectsVisor.instance;

    this.container = __dom;
    this.visible = false;

    this.video = new VideoMultiple(__dom);
    this.progressScroller = new ProgressScroller();

    this._calls.click = e => this._click(e);
    //document.addEventListener(Basics.clickEvent, this._calls.click, { capture: true });

    this.video.onChange = __n => CircleVisor.select(__n);
    this.progressScroller.onStartScroll = () => this._focus(true);
    this.progressScroller.onEndScroll = () => this._focus(false);
    CircleVisor.onMouseOver = () => this._focus(true);
    CircleVisor.onMouseOut = () => this._focus(false);
    CircleVisor.onItemMouseOver = item => this._selectItem(item);
    CircleVisor.onItemMouseOut = item => this._selectItem(item);

    ProjectsVisor.instance = this;
  }

  _click(e) {
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    if(this.item) {
      this.progressScroller.goto(this.item.index/this.video.total);
    }
  }

  _focus(__isFocus) {
    if (__isFocus) EventDispatcher.dispatchEvent("FOCUS_ON");
    else if (!CircleVisor.isMouseOver) EventDispatcher.dispatchEvent("FOCUS_OFF");
  }

  _selectItem(__item) {
    this.item = __item;
  }

  show(__isFirstTime = false) {
    if (this.visible) return;
    this.visible = true;
    
    if(!__isFirstTime) this.progressScroller.start();
    
    this.video.show();
    if(!CircleVisor.isPreload) CircleVisor.show();
  }

  hide(__call) {
    CircleVisor.hide();
    __call();
    if (!this.visible) return;
    this.visible = false;
    console.log('ProjectsVisor → hide');
  }

  loop() {
    CircleVisor.cabezal.setTimerText(this.video.screenTime);
    this.progressScroller.loop();
    this._calculateSpeed();
    this.video.loop();
  }

  _calculateSpeed() {
    const velocity = this.progressScroller.speed * 0.02;

    if (Math.abs(velocity) > 0.01) {
      CircleVisor.speed = -velocity * 0.035;
      this.video.changeTime(this.video.currentTime - velocity);
    } else {
      CircleVisor.speed = this.video.isReady? 0.01 * 0.035 : 0;
    }
    CircleVisor.progress = this.video.progress;
  }

  resize() {
    this.progressScroller.resize();
  }

  dispose() {
    // Ocultar visor
    this.visible = false;

    // Detener video y scroller
    this.video?.dispose?.();
    this.progressScroller?.dispose?.();

    // Eliminar todos los listeners guardados en _calls
    if (this.container && this._calls.click) {
      this.container.removeEventListener('click', this._calls.click, true);
    }

    CircleVisor.disposeModeHome();

    // Limpiar referencias de funciones
    for (let key in this._calls) this._calls[key] = null;

    // Limpiar objetos
    this.video = null;
    this.progressScroller = null;
    this.container = null;
    this._calls = null;

    ProjectsVisor.instance = null;

    console.log('ProjectsVisor → disposed');
  }
}
